import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-321ff04a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "option-id": "1" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "size-ttl" }, "ワイドタイプ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "size-txt" }, [
  /*#__PURE__*/_createTextVNode(" 外寸：高さ35.0cm × 幅27.0cm × 奥行22.5cm"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 大マチ内寸：高さ32.0cm × 幅24.0cm × 奥行12.5cm"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 小マチ内寸：高さ25.0cm × 幅24.0cm × 奥行3.0cm（MAX5.0cm）"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 重量：1,330g前後"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_5 = { "option-id": "2" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "size-ttl" }, "スリムタイプ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "size-txt" }, [
  /*#__PURE__*/_createTextVNode(" 外寸：高さ35.0cm × 幅27.0cm × 奥行20.0cm"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 大マチ内寸：高さ32.0cm × 幅24.0cm × 奥行10.0cm"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 小マチ内寸：高さ25.0cm × 幅24.0cm × 奥行3.0cm（MAX5.0cm）"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 重量：1,260g前後"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "bagsize-note" }, [
  /*#__PURE__*/_createTextVNode(" ※シミュレータは12.5cmのワイドタイプを表示しています。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ※シミュレータ上ではランドセルの大きさは変化しません。"),
  /*#__PURE__*/_createElementVNode("br")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RandselDialog = _resolveComponent("RandselDialog")!

  return (_openBlock(), _createBlock(_component_RandselDialog, {
    title: "タイプ詳細",
    showEventName: "openBagsizeDialog",
    class: "bagsize-dialog"
  }, {
    default: _withCtx(() => [
      _createElementVNode("ul", null, [
        _createElementVNode("li", _hoisted_1, [
          _createElementVNode("img", {
            src: require('@/assets/images/img_half_wide.png')
          }, null, 8, _hoisted_2),
          _hoisted_3,
          _hoisted_4
        ]),
        _createElementVNode("li", _hoisted_5, [
          _createElementVNode("img", {
            src: require('@/assets/images/img_half_slim.png')
          }, null, 8, _hoisted_6),
          _hoisted_7,
          _hoisted_8
        ])
      ]),
      _hoisted_9
    ]),
    _: 1
  }))
}